export * from './userTags.constants';
export * from './smsTemplateTags.constants';
export * from './subscriptions.constans';

export const Absence = {
  MAX_CHARS_NAME: 100,
  MAX_CHARS_NOTE: 2000,
};

export const Staff = {
  ID_PREFIX: 'stf-',
};

export const AutoResponseMessage = {
  DEFAULT:
    'Vielen Dank, wir haben Ihre Nachricht erhalten und werden Ihnen sobald wie möglich antworten.',
  MAX_LENGTH: 2000,
};

export enum CustomClientEvents {
  INBOX_SEARCH_QUERY_CHANGED = 'inbox-webapp:searchQueryChanged',
}

export const SmsSenderName = {
  MAX_LENGTH: 11,
};

export const AnonymousUserChat = {
  firstName: 'Anonymous',
  lastName: 'Anonymous',
};

export const SessionProviders = {
  MEDFLEX: 'medflex',
  ARZT_KONSULTATION: 'arztKonsultation',
};
